import {
	ORDER_STATUS_QUERY_PARAM_DEFAULT,
	ORDER_STATUS_QUERY_PARAM_KEY,
	PAYMENT_FOR,
} from '../constants/orderStatus.constants';

const decodeCheckoutReturnUrl = (encodedUrl) => {
	if (!encodedUrl) {
		return null;
	}

	try {
		return decodeURIComponent(encodedUrl);
	} catch {
		return encodedUrl;
	}
};

const QUERY_PARAM_READERS = [
	{
		key: 'redirectStatus',
		read: (query) => query.get(ORDER_STATUS_QUERY_PARAM_KEY.REDIRECT_STATUS),
	},
	{
		key: 'paymentIntent',
		read: (query) =>
			query.get(ORDER_STATUS_QUERY_PARAM_KEY.PAYMENT_INTENT) ||
			query.get(ORDER_STATUS_QUERY_PARAM_KEY.SETUP_INTENT),
	},
	{
		key: 'paymentFor',
		read: (query) =>
			query.get(ORDER_STATUS_QUERY_PARAM_KEY.PAYMENT_FOR) ||
			PAYMENT_FOR.PLAN,
	},
	{
		key: 'fromQuiz',
		read: (query) => query.get(ORDER_STATUS_QUERY_PARAM_KEY.FROM_QUIZ) === '1',
	},
	{
		key: 'isPromo',
		read: (query) => query.get(ORDER_STATUS_QUERY_PARAM_KEY.PROMO) === '1',
	},
	{
		key: 'browsingPersonId',
		read: (query) =>
			query.get(ORDER_STATUS_QUERY_PARAM_KEY.BROWSING_PERSON) || null,
	},
	{
		key: 'purchaseValue',
		read: (query) => {
			const raw = query.get(ORDER_STATUS_QUERY_PARAM_KEY.PURCHASE_VALUE);
			const value = Number.parseFloat(raw);
			return Number.isFinite(value) ? value : null;
		},
	},
	{
		key: 'purchaseCurrency',
		read: (query) =>
			query.get(ORDER_STATUS_QUERY_PARAM_KEY.PURCHASE_CURRENCY) || null,
	},
	{
		key: 'email',
		read: (query) => query.get(ORDER_STATUS_QUERY_PARAM_KEY.EMAIL),
	},
	{
		key: 'studioStateEncoded',
		read: (query) => query.get(ORDER_STATUS_QUERY_PARAM_KEY.STUDIO_STATE),
	},
	{
		key: 'checkoutReturnUrl',
		read: (query) => query.get(ORDER_STATUS_QUERY_PARAM_KEY.CHECKOUT_RETURN_URL),
	},
	{
		key: 'returnPath',
		read: (query) =>
			decodeURIComponent(
				query.get(ORDER_STATUS_QUERY_PARAM_KEY.RETURN_PATH) ||
					ORDER_STATUS_QUERY_PARAM_DEFAULT.RETURN_PATH,
			),
	},
];

export const parseOrderStatusQueryParams = (query) => {
	const params = QUERY_PARAM_READERS.reduce((acc, { key, read }) => {
		acc[key] = read(query);
		return acc;
	}, {});

	return {
		...params,
		checkoutReturnUrl: decodeCheckoutReturnUrl(params.checkoutReturnUrl),
		isTokenPayment: params.paymentFor === PAYMENT_FOR.TOKENS,
		isStripeSuccess:
			query.get(ORDER_STATUS_QUERY_PARAM_KEY.RESULT) === 'success' &&
			params.redirectStatus !== 'failed',
	};
};
